import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-block text-area" }
const _hoisted_2 = { for: "" }
const _hoisted_3 = {
  id: "cars",
  class: "form-control"
}
const _hoisted_4 = {
  key: 0,
  class: "action-button"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" })
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", _hoisted_2, _toDisplayString(_ctx.data.title), 1),
    _createVNode("select", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.select_values, (option, optionIndex) => {
        return (_openBlock(), _createBlock("option", {
          value: option.value,
          key: optionIndex
        }, _toDisplayString(option.text), 9, ["value"]))
      }), 128))
    ]),
    (_ctx.editStatus)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6
        ]))
      : _createCommentVNode("", true)
  ]))
}